import {
  isDateRangeFilter,
  setDateValidationErrors,
} from '@user/components/Filters'
import { DraftLead, DraftLeadFilterSet } from '@user/store/draftLeads'
import { FormikErrors } from 'formik'

export function validateDraftLeadFilters(values: DraftLeadFilterSet) {
  const { filters } = values

  const errors: FormikErrors<DraftLeadFilterSet> = {}
  for (const filter in filters) {
    if (isDateRangeFilter<DraftLead>(filters[filter])) {
      setDateValidationErrors(filters[filter], errors)
    }
  }

  return errors
}
